// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"204":"7a4c74cf","346":"dc583cc3","734":"dc583cc3"}[chunkId] + ".chunk.css";
};